import type { RealtimeVerify } from './types'

// The declarative inbound-signature check (09-realtime-triggers.md): HMAC the raw body with a secret drawn
// from config, compare it in constant time to the header the provider sent, and — when the provider stamps
// its deliveries — reject anything too old to be a live event rather than a replay.
//
// Services cannot `require` node modules, so the primitives come from `Flowrunner.crypto` (see ../crypto).
// An author who needs something this shape cannot express writes `verifyRequest` instead.

export function verifyDeclarative(
  verify: RealtimeVerify,
  rawBody: string | undefined,
  headers: Record<string, unknown>,
  config: Record<string, unknown>
): boolean {
  const provided = (headers[verify.header] ?? headers[verify.header.toLowerCase()]) as string | undefined

  if (!provided) {
    return false
  }

  const computed = Flowrunner.crypto.hmac(verify.algo, verify.secret(config), rawBody ?? '', verify.encoding)

  if (!Flowrunner.crypto.timingSafeEqual(provided, computed)) {
    return false
  }

  if (verify.freshness && verify.timestampHeader) {
    const timestamp = headers[verify.timestampHeader] as string | undefined

    if (timestamp && Flowrunner.crypto.ageSeconds(timestamp) > verify.freshness) {
      return false
    }
  }

  return true
}
